import { useState } from "react";
import headingImg from "../assets/heading-img.png";
import sampleblogimg from "../assets/sample-blog-img.jpg";
import { useNavigate } from "react-router-dom";
import Light from "../assets/Light.png";
import PageTransition from "../PageTransition";
import "../Intel.css";
import Footer from "./Footer";
import Header from "./Header";
import { Helmet } from "react-helmet-async";

import blog2img from '../assets/design-mistakes-that-costs-you-later-main.webp'
import blog3img from '../assets/website-audit-guide-10-step-checklist-main.webp'
import blog4img from '../assets/why-does-your-website-not-getting-any-leads-main.webp'
import blog5img from '../assets/quick-fixes-to-improve-website-speed-and-user-engagement-main.webp'
import blog6img from '../assets/the-champagne-coffee-problems.webp'
import blog7img from '../assets/manufacturing-challenges-ai-solutions-2026.webp'


export default function ContentIntel() {
    const [activated, setActivated] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
const navigate = useNavigate();


  return (
    <>

    <Helmet>
  <title>Intel Case Study: UX & Web Performance Optimization | 2 Light Years</title>

  <meta 
    name="description" 
    content="Explore how 2 Light Years improved UX, speed, and conversion performance for Intel through strategic design and web optimization." 
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://www.2lightyears.com/intel" />

  {/* Open Graph (Facebook / LinkedIn) */}
  <meta property="og:title" content="Intel Case Study | 2 Light Years" />
  <meta property="og:description" content="UX, performance and conversion optimization case study for Intel." />
  <meta property="og:url" content="https://www.2lightyears.com/intel" />
  <meta property="og:type" content="article" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Intel Case Study | 2 Light Years" />
  <meta name="twitter:description" content="See how we optimized UX and performance for Intel." />
</Helmet>

           <Header visible mode="normal" />
      <PageTransition>
  

      <section
        id="intelcontainer"
        className="d-flex justify-content-start align-items-center  p-4 flex-column"
      >
        <div className="main-blog-section d-flex justify-content-between align-items-center flex-column col-xl-12">
          <div className="main-blog-section-top d-flex justify-content-between ">
            <div className="main-blog-section-top-date">
              17.02.2018
              <br /> Date published
            </div>

            <div className="main-blog-section-top-tag">• Production</div>
          </div>

          <div className="main-blog-section-bottom d-flex justify-content-between ">
            <div className="main-blog-section-bottom-content">
              How to Improve photography using Iphone
            </div>

            <div className="main-blog-section-bottom-button">
              <a href="/intel/how-to-take-better-photos-on-iphone">
                READ MORE{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-arrow-right-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="cards-blog-section d-flex justify-content-center align-items-center flex-column  col-xl-12 container">
          <div className="cards-blog-section-heading">
            <h1 className="w-100 text-start">LATEST BLOGS</h1>
          </div>
          <div className="cards-blog-section-container ">
            {/* single card item start */}
            <div className="cards-blog-section-single-card d-flex justify-content-center align-items-center flex-column">
              <div className="cards-blog-section-single-card-top d-flex justify-content-between align-items-center w-100">
                <div className="cards-blog-section-single-card-top-left">
                  17.8.2025
                  <br /> Date Published
                </div>

                <div className="cards-blog-section-single-card-top-rigt">
                  • Design
                </div>
              </div>

              <div className="cards-blog-section-single-card-content">
                Design mistakes that cost you later
              </div>

               <div className="cards-blog-section-single-card-bottom d-flex "
  style={{ backgroundImage: `url(${blog2img})` }}>
    
                <a href="/intel/branding-design-mistakes-that-cost-you-later" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          {/* single card item end */}
            {/* single card item start */}
            <div className="cards-blog-section-single-card d-flex justify-content-center align-items-center flex-column">
              <div className="cards-blog-section-single-card-top d-flex justify-content-between align-items-center w-100">
                <div className="cards-blog-section-single-card-top-left">
                  17.8.2025
                  <br /> Date Published
                </div>

                <div className="cards-blog-section-single-card-top-rigt">
                  • Website
                </div>
              </div>

              <div className="cards-blog-section-single-card-content">
                Is Your website healthy? Audit it with 10 steps
              </div>

               <div className="cards-blog-section-single-card-bottom d-flex "
  style={{ backgroundImage: `url(${blog3img})` }}>
                <a href="/intel/website-audit-guide-10-step-checklist" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          {/* single card item end */}
            {/* single card item start */}
            <div className="cards-blog-section-single-card d-flex justify-content-center align-items-center flex-column">
              <div className="cards-blog-section-single-card-top d-flex justify-content-between align-items-center w-100">
                <div className="cards-blog-section-single-card-top-left">
                  17.8.2025
                  <br /> Date Published
                </div>

                <div className="cards-blog-section-single-card-top-rigt">
                  • Branding
                </div>
              </div>

              <div className="cards-blog-section-single-card-content">
                What a Branding Kit Looks Like in 2026
              </div>

               <div className="cards-blog-section-single-card-bottom d-flex "
  style={{ backgroundImage: `url(${blog6img})` }}>
                <a href="/intel/what-is-a-branding-kit-2026-guide" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          {/* single card item end */}
        
          </div>
        </div>

        <div className="cards-blog-section d-flex justify-content-center align-items-center flex-column  col-xl-12 container">
          <div className="cards-blog-section-heading">
            <h1 className="w-100 text-start">EXPLORE</h1>
          </div>
          <div className="cards-blog-section-container ">
            {/* single card item start */}
            <div className="cards-blog-section-single-card d-flex justify-content-center align-items-center flex-column">
              <div className="cards-blog-section-single-card-top d-flex justify-content-between align-items-center w-100">
                <div className="cards-blog-section-single-card-top-left">
                  17.8.2025
                  <br /> Date Published
                </div>

                <div className="cards-blog-section-single-card-top-rigt">
                  • Website
                </div>
              </div>

              <div className="cards-blog-section-single-card-content">
                Quick Fixes to Launch Your Website’s Speed 
              </div>

               <div className="cards-blog-section-single-card-bottom d-flex "
  style={{ backgroundImage: `url(${blog5img})` }}>
                <a href="/intel/quick-fixes-to-improve-website-speed-and-user-engagement" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          {/* single card item end */}

            {/* single card item start */}
            <div className="cards-blog-section-single-card d-flex justify-content-center align-items-center flex-column">
              <div className="cards-blog-section-single-card-top d-flex justify-content-between align-items-center w-100">
                <div className="cards-blog-section-single-card-top-left">
                  07.04.2026
                  <br /> Date Published
                </div>

                <div className="cards-blog-section-single-card-top-rigt">
                  • Branding 
                </div>
              </div>

              <div className="cards-blog-section-single-card-content">
                The <s>Champagne </s> Coffee...
              </div>

               <div className="cards-blog-section-single-card-bottom d-flex "
  style={{ backgroundImage: `url(${blog6img})` }}>
                <a href="/intel/the-champagne-coffee-problems" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          {/* single card item end */}
              {/* single card item start */}
            <div className="cards-blog-section-single-card d-flex justify-content-center align-items-center flex-column">
              <div className="cards-blog-section-single-card-top d-flex justify-content-between align-items-center w-100">
                <div className="cards-blog-section-single-card-top-left">
                  30.04.2026
                  <br /> Date Published
                </div>

                <div className="cards-blog-section-single-card-top-rigt">
                  • Industry
                </div>
              </div>

              <div className="cards-blog-section-single-card-content">
                When the Factory Floor Meets Artificial...
              </div>

               <div className="cards-blog-section-single-card-bottom d-flex "
  style={{ backgroundImage: `url(${blog7img})` }}>
                <a href="/intel/manufacturing-challenges-ai-solutions-2026" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          {/* single card item end */}

          

          </div>
        </div>
      </section>
    </PageTransition>
    </>
  );
}
